import dynamic from 'next/dynamic'

const AuthenticationModals = dynamic(
  import(
    /* webpackChunkName: "authentication" */
    'components/Authentication/Modals/Auth'
  ),
  {
    ssr: false,
  }
)

export default AuthenticationModals
